import type { DateOnly } from "@/shared/components/date-picker";

export interface CustomEmailValue {
	id: string;
	email: string;
	selected: boolean;
}

export interface CalendarEmailFormValues {
	notifyByEmail: boolean;
	selectedDefaultEmails: string[];
	customEmails: CustomEmailValue[];
	publisherNote: string;
}

export interface EmailCalendarFormValues extends CalendarEmailFormValues {
	fromDate: DateOnly | null;
	toDate: DateOnly | null;
}

export const getSelectedRecipients = (
	values: CalendarEmailFormValues,
): string[] => {
	if (!values.notifyByEmail) return [];

	return [
		...values.selectedDefaultEmails,
		...values.customEmails
			.filter(({ email, selected }) => selected && email.trim())
			.map(({ email }) => email.trim()),
	];
};

export const hasNonDefaultRecipients = (
	values: CalendarEmailFormValues,
): boolean =>
	values.notifyByEmail &&
	values.customEmails.some(
		({ email, selected }) => selected && Boolean(email.trim()),
	);
